export default "__VITE_ASSET__CdE9eYmr__"